import React from 'react';

const WorkCenterList = ({ centrosTrabajo, selectedWorkCenterId, onSelectWorkCenter }) => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg max-w-2xl mx-auto mb-6 transition-colors duration-300">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Centros de Trabajo</h2>
      {centrosTrabajo.length === 0 ? (
        <p className="text-gray-500 text-center text-base">No hay centros de trabajo para esta planta.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {centrosTrabajo.map(centro => (
            <button
              key={centro.id}
              onClick={() => onSelectWorkCenter(centro.id)}
              className={`py-3 px-4 rounded-lg font-semibold transition-colors border-2 text-base ${
                selectedWorkCenterId === centro.id
                  ? 'bg-emerald-600 text-white border-emerald-600 shadow-md'
                  : 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200'
              }`}
            >
              {centro.nombre}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default WorkCenterList;